export default function getWordValOfWordObj(state, wordObj) {
	return wordObj.word;
}


// WEBPACK FOOTER //
// ./src/selectors/getWordValOfWordObj.js